import React from 'react'
import { useHistory } from 'react-router-dom'
import PropTypes from 'prop-types'

import ModalContainer from '../../modal-container'
import Button from '../../button'
import styles from './streaming-limit-popup.css'

function StreamingLimitPopup({ message }) {
  const history = useHistory()

  const onDismiss = () => {
    if (history.location.key) {
      // Back to previous page
      history.goBack()
    } else {
      // In a new tab, back to home page
      history.push('/')
    }
  }

  return (
    <ModalContainer onRequestClose={onDismiss}>
      <div className={styles.contentBox}>
        <div className={styles.contentFrame}>
          <div className={styles.text}>{message}</div>
          <Button
            onClick={onDismiss}
            className={styles.button}
            e2eIdentifier="streaming-limit-close-button"
            text="OK"
            darkBGSecondary
          />
        </div>
      </div>
    </ModalContainer>
  )
}

StreamingLimitPopup.propTypes = {
  message: PropTypes.string
}

StreamingLimitPopup.defaultProps = {
  message: ''
}

export default StreamingLimitPopup
